var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightlifting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.059 9.44 0 4.39-.86.001c-1.215 0-2.199-.983-2.199-2.195 0-1.213.984-2.196 2.199-2.196l.86 0Zm43.815 0 .927 0c1.215 0 2.199.983 2.199 2.196 0 1.212-.984 2.195-2.199 2.195l-.927 0 0-4.391Zm-36.886 0 0 4.391-5.071 0 0-4.391 5.071 0Zm6.952 0 0 4.39-5.071 0 0-4.392 5.071.001Zm14.05 0 0 4.39-12.192 0 0-4.39 12.192 0Zm6.952 0 0 4.39-5.093 0 0-4.39 5.093 0Zm7.074 0 0 4.39-5.094 0 0-4.39 5.094 0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.941 0 16.941 23.261 11.847 23.261 11.847 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.943 0 37.943 23.261 32.849 23.261 32.849 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.012 5.098 10.012 18.163 4.918 18.163 4.918 5.098"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.017 5.098 45.017 18.163 39.923 18.163 39.923 5.098"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightlifting);
export default __webpack_public_path__ + "static/media/weightlifting.515623f5b3246e784b61d10b582fcbee.svg";
export { ForwardRef as ReactComponent };